// src/components/SidebarContext.jsx
import { createContext, useContext, useState } from "react";

// Context para gerenciar estado do sidebar mobile
const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <SidebarContext.Provider value={{ mobileOpen, setMobileOpen }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
}